import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { SheetWithFormSchema } from '@/components/ui/SheetWithFormSchema'
import { useSubmitForm } from '../FormComponent/useSubmitForm'
import { Button } from '@/components/shadcn/button'
import { IconEditOutline } from '@icons/IconEditOutline'
import { InferFormValues, JsonFormSchemaV2 } from '../FormComponent/types'

export function EditAction({ handlerId, schema }: { handlerId: string; schema: JsonFormSchemaV2 }) {
  const { tileFilterSelections } = useTileFilters()
  const { mutate: submitForm, isPending: isSubmitting } = useSubmitForm(handlerId, tileFilterSelections)

  return (
    <SheetWithFormSchema
      wide
      triggerTooltip="Edit"
      trigger={
        <Button variant="ghost" size="icon" className="size-8 rounded-full">
          <IconEditOutline />
          <span className="sr-only">Edit</span>
        </Button>
      }
      schema={schema}
      closeOnSuccess
      onSubmit={(data: InferFormValues<typeof schema>, onSuccess) => {
        // Call submitForm with the data and pass the onSuccess callback to be executed only on success
        submitForm(data, {
          onSuccess: () => {
            if (onSuccess) {
              onSuccess()
            }
          },
        })
      }}
      isSubmitting={isSubmitting}
    />
  )
}
